import * as PIXI from "pixi.js";
import Game from "./Game";
import Layers from "./layers/Layers";
import { rootEventBus, EnumRootEventBus } from "./managers/RootEventBus";
import addInteractivity from "./utils/addInteractivity";
import getCleanCoord from "./utils/coord/getCleanCoord";
import { CustomCursorType } from "./entities/UI/CustomCursor/CustomCursor";
import { cursorEventBus, EnumCursorEventBus } from "./entities/UI/CustomCursor/CustomCursorEventBus";


export default class InteractivityComponent extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private lastUnixTime = 0;
  private currCursorType = CustomCursorType.default;

  constructor() {
    super();

    this.addBg();
    this.setLayer(false);
    this.addInteractivity();

    rootEventBus.on(EnumRootEventBus.setInteractLayer, (isDowned: boolean) => this.setLayer(isDowned));
    cursorEventBus.on(EnumCursorEventBus.setInteractLayerCursor, (c: CustomCursorType) => this.currCursorType = c);

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.interactive = false);
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.interactive = true);
  }

  private setLayer = (isDown: boolean) => {
    const layer = isDown ? "UITop" : "Top";
    this.parent?.removeChild(this);
    this.Layers[`${layer}`].addChild(this);
  };
  private addBg() {
    const texture = new PIXI.Texture(PIXI.Texture.EMPTY);
    const sprite = this.addChild(new PIXI.Sprite(texture));
    const dim = this.Game.getDim();

    sprite.width = dim.WIDTH;
    sprite.height = dim.HEIGHT;
    sprite.position.copyFrom({ x: 0, y: 0 });
  }
  private addInteractivity() {
    addInteractivity(
      this,
      {
        handleDownFunc: (e: PIXI.FederatedPointerEvent) => this.handlePointerDown(e),
        handleMoveFunc: (e: PIXI.FederatedPointerEvent) => this.handlePointerMove(e),
        handleUpFunc: (e: PIXI.FederatedPointerEvent) => this.handlePointerUp(e),
        handleOutFunc: (e: PIXI.FederatedPointerEvent) => this.handlePointerUp(e),
        handleUpOutSideFunc: (e: PIXI.FederatedPointerEvent) => this.handlePointerUp(e)
      },
      CustomCursorType.default,
      true
    );
  }
  private handlePointerUp(e: PIXI.FederatedPointerEvent) {
    const coord = getCleanCoord(e.global);
    rootEventBus.emit(EnumRootEventBus.setPointerUp, coord);
  };
  private handlePointerDown(e: PIXI.FederatedPointerEvent) {
    const coord = getCleanCoord(e.global);
    rootEventBus.emit(EnumRootEventBus.setPointerDown, coord);
  }
  private handlePointerMove(e: PIXI.FederatedPointerEvent) {
    const UnixTime = Date.now();
    if (UnixTime >= this.lastUnixTime + 5) {
      this.lastUnixTime = UnixTime;
      const coord = getCleanCoord(e.global);
      cursorEventBus.emit(EnumCursorEventBus.setCursor, this.currCursorType);
      rootEventBus.emit(EnumRootEventBus.setPointerMove, coord);
    }
  }
}